export default "__VITE_ASSET__BXAeTj2j__"